export default __webpack_public_path__ + "static/media/104.46fe96a9.jpg";